import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import Deletion from "./pages/Deletion";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/deletion" element={<Deletion />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;